import PropTypes from 'prop-types';
import { DownloadFile } from '../utils/DownloadFile';
import { CREW_DETAILS_TEMPLATE_NAME, GENERAL_DECLARATION_TEMPLATE_NAME, PASSENGER_DETAILS_TEMPLATE_NAME } from '../constants/AppConstants';

const DownloadTemplates = ({ isLandingPage, isTemplatePage }) => {
  const fal1 = <button className="govuk-button--text text-align--left" type="button" onClick={() => DownloadFile('assets/files/General declaration (FAL 1).xlsx', 'General declaration (FAL 1).xlsx')}>{`${GENERAL_DECLARATION_TEMPLATE_NAME} form (xlsx, 31kb)`}</button>;
  const fal3 = <button className="govuk-button--text text-align--left" type="button" onClick={() => DownloadFile("assets/files/Ship's stores declaration FAL 3.xlsx", "Ship's stores declaration FAL 3.xlsx")}>Ship&apos;s Stores Declaration (FAL 3) form (xlsx, 23kb)</button>;
  const fal4 = <button className="govuk-button--text text-align--left" type="button" onClick={() => DownloadFile('assets/files/Crew Effects FAL 4.xlsx', 'Crew Effects FAL 4.xlsx')}>Crew effects (FAL 4) form (xlsx, 24kb)</button>;
  const fal5 = <button className="govuk-button--text text-align--left" type="button" onClick={() => DownloadFile('assets/files/Crew details (FAL 5).xlsx', 'Crew details (FAL 5).xlsx')}>{`${CREW_DETAILS_TEMPLATE_NAME} form (xlsx, 118kb)`}</button>;
  const fal6 = <button className="govuk-button--text text-align--left" type="button" onClick={() => DownloadFile('assets/files/Passenger details including supernumeraries (FAL 6).xlsx', 'Passenger details including supernumeraries (FAL 6).xlsx')}>{`${PASSENGER_DETAILS_TEMPLATE_NAME} form (xlsx, 90kb)`}</button>;

  return (
    <>
      {isLandingPage && (
        <ul className="govuk-list govuk-list--bullet govuk-!-margin-bottom-7">
          <li>
            {fal1}
          </li>
          <li>
            {isLandingPage && 'passport or travel document details for all crew entered on a '}
            {fal5}
          </li>
          <li>
            {isLandingPage && 'passport or travel document details for all passengers entered on a '}
            {fal6}
          </li>
        </ul>
      )}

      {isTemplatePage && (
        <>
          <h2 className="govuk-heading-m">Required forms</h2>
          <ul className="govuk-list govuk-list govuk-!-margin-bottom-7">
            <li>{fal1}</li>
            <li>{fal5}</li>
          </ul>
          <h2 className="govuk-heading-m">If there are passengers or supernumeraries</h2>
          <ul className="govuk-list govuk-list govuk-!-margin-bottom-7">
            <li>{fal6}</li>
          </ul>
          <h2 className="govuk-heading-m">Supporting documents</h2>
          <p className="govuk-body">If you need to declare anything further use these forms: </p>
          <ul className="govuk-list govuk-list--bullet govuk-!-margin-bottom-7">
            <li>{fal3}</li>
            <li>{fal4}</li>
          </ul>
        </>
      )}

      {(!isLandingPage && !isTemplatePage) && (
        <ul className="govuk-list govuk-list--bullet govuk-!-margin-bottom-7">
          <li>{fal1}</li>
          <li>{fal5}</li>
          <li>{fal6}</li>
        </ul>
      )}
    </>

  );
};

export default DownloadTemplates;

DownloadTemplates.propTypes = {
  isLandingPage: PropTypes.bool,
  isTemplatePage: PropTypes.bool,
};
